export const WelcomeUserReducer = (state, action) => {
  switch (action.type) {
    case "GET_USER_DATA":
      return {
        ...state,
        user: {
          ...state.user,
          ...action.data,
        },
        isLoading: false,
        isError: false,
        isErrorMessage: [],
      };
    case "GET_USER_ERROR":
      return {
        ...state,
        isLoading: false,
        isError: true,
        isErrorMessage: [...state.isErrorMessage, action.message],
      };
    default:
      return state;
  }
};
